// COCO-3424 Holiday Badge ABTest - after test is done, related changes will be removed
// post-test cleanup ticket: https://lululemon.atlassian.net/browse/COCO-2658
import * as React from "react";
import PropTypes from "prop-types";

export const convertKeysToDashRecursive = (data) => {
  if (Array.isArray(data)) {
    return data.map((item) => convertKeysToDashRecursive(item));
  } else if (
    data !== null &&
    typeof data === "object" &&
    !Array.isArray(data)
  ) {
    return Object.keys(data).reduce((acc, key) => {
      const dashedKey = key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
      // eslint-disable-next-line security/detect-object-injection
      acc[dashedKey] = convertKeysToDashRecursive(data[key]);
      return acc;
    }, {});
  }
  return data;
};

const GiftHighlight = ({
  highlights,
  className,
  productHighlightComponent,
  highlightType
}) => {
  const productHighlights = {
    highlights: convertKeysToDashRecursive(highlights)
  };

  const ProductHighlight = productHighlightComponent;

  return (
    <ProductHighlight
      product={productHighlights}
      className={className}
      variation="pill"
      page={highlightType}
    />
  );
};

GiftHighlight.propTypes = {
  className: PropTypes.string,
  highlights: PropTypes.arrayOf(
    PropTypes.shape({
      highlightIconWeb: PropTypes.string,
      highlightLabel: PropTypes.string
    })
  )
};

GiftHighlight.defaultProps = {
  className: "",
  highlights: []
};

export default GiftHighlight;
